import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PaymentLoanPlanApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'paymentLoanPlan'
  }

}